import { DateTime } from 'luxon'
import React from 'react'
import { Control, useController } from 'react-hook-form'

import { DatePicker } from '@components/date-picker.component'
import { FieldHeaderContent } from '@src/pages/workflow/client/fields/field-header-content.component'

type WorkflowDateProps = {
  field: Field
  readOnly?: boolean
  isRequired?: boolean
  section: ActivitySection
  control: Control
}

export function WorkflowDate({
  field,
  readOnly,
  isRequired,
  section,
  control,
}: WorkflowDateProps) {
  const {
    field: { onChange, value, disabled, ...fieldProps },
    fieldState: { error },
  } = useController({
    disabled: readOnly,
    name: `${field.version}_${field.id}`,
    control,
    rules: {
      required: isRequired && 'This field is required',
    },
  })

  function handleChange(date: DateTime | null) {
    if (disabled) return
    onChange(date ? date.toISO() : null)
  }

  function handleClear() {
    if (disabled) return
    onChange(null)
  }

  return (
    <>
      <FieldHeaderContent
        field={field}
        isRequired={isRequired}
        section={section}
      />
      <DatePicker
        placeholder="Select date"
        value={value ? DateTime.fromISO(value) : null}
        onChange={handleChange}
        triggerIsBlock
        error={error?.message}
        onClear={handleClear}
        fixedContent
        {...fieldProps}
      />
    </>
  )
}
